import type { Slide } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { BaseSceneSwapBridge } from 'js/src/libs/scene-swapping/BaseBridge';

export class VoiceoverToCommonBridge extends BaseSceneSwapBridge {
    override _from = VideoData.CATEGORY_VOICEOVER;
    override _to = VideoData.CATEGORY_COMMON;

    override _isSwapAllowedFor(originalScene: Slide): boolean {
        // you can swap a voiceover scene to a common scene
        return true;
    }
}
